import { policyList } from "@/enums/permissions";
import { EventBus } from "@/event-bus";
import { AccountManagement } from "@/interfaces/accountManagement";
import accountServices from "@/services/account.services";
import { Callback } from "@/types/types";
import {
  BooleanCheck,
  NumericPickerComponent,
  PageTitleComponent,
  TableComponent
} from "helix-vue-components";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Template from "./AccountManagement.template.vue";
import AutoBillConfigurationModal from "./AutoBillConfigurationModal/AutoBillConfigurationModal.component";
// import BillingBreakdownSubTable from "./BillingBreakdownSubTable/BillingBreakdownSubTable.component";
import { AccountManagementTable } from "./declarations";
import LocationSeatsManagerModal from "./LocationSeatsManagerModal/LocationSeatsManagerModal.component";
import PayBillModal from "./PayBillModal/PayBillModal.component";
import UsersSeatsManagerModal from "./UsersSeatsManagerModal/UsersSeatsManagerModal.component";
@Component({
  mixins: [Template],
  components: {
    PageTitleComponent,
    TableComponent,
    // BillingBreakdownSubTable,
    "numeric-picker": NumericPickerComponent
  }
})
export default class AccountManagementComponent extends Vue {
  public loadingAutoBill = false;
  public tableData = AccountManagementTable;
  @Getter("accountData", { namespace: "AccountManagementModule" })
  public account!: AccountManagement.Account;
  @Getter("loading", { namespace: "AccountManagementModule" })
  public loading!: boolean;
  @Getter("availability", { namespace: "AccountManagementModule" })
  public availability!: AccountManagement.Availability;
  @Getter("loadingAvailability", { namespace: "AccountManagementModule" })
  public loadingAvailability!: boolean;
  @Getter("hasPermission", { namespace: "authModule" })
  public hasPermission!: BooleanCheck;
  @Action("loadAccountData", { namespace: "AccountManagementModule" })
  protected accountDataAction!: Callback;
  @Action("loadAvailability", { namespace: "AccountManagementModule" })
  protected loadAvailability!: Callback;
  protected colors = ["white", "#f2f2f2", "#f2f2f2"];

  protected AUTO_BILL = false;
  protected policyList = policyList;

  public async setupAutoBill() {
    this.$modals
      .load<AccountManagement.CreditCard>(
        AutoBillConfigurationModal,
        {
          size: "fit",
          positionY: "top"
        },
        {
          nextPaymentDate: this.account.next_bill_date
        }
      )
      .then(
        async card => {
          await accountServices.starCreditCard(
            // @ts-ignore
            this.account.account.id,
            card.id
          );
        },
        () => {
          // Nothing
        }
      );
  }
  public manageUsers() {
    const userAvailability = this.availability.users;
    this.$modals
      .load<{ users: number }>(
        UsersSeatsManagerModal,
        {
          size: "fit",
          positionY: "top"
        },
        {
          usersSeats: userAvailability.addon,
          min:
            userAvailability.used > userAvailability.plan
              ? userAvailability.used - userAvailability.plan
              : 0,
          costPerUnit: userAvailability.cost_per_unit
        }
      )
      .then(
        async data => {
          const users = data.users;
          await accountServices.setExtraUsers(this.account.id, users);
          this.loadAvailability();
        },
        () => {
          // Nothing to do on modal close...
        }
      );
  }
  public manageLocations() {
    const locationsAvailability = this.availability.locations;
    this.$modals
      .load<{ locations: number }>(
        LocationSeatsManagerModal,
        {
          size: "fit",
          positionY: "top"
        },
        {
          locationSeats: locationsAvailability.addon,
          min:
            locationsAvailability.used > locationsAvailability.plan
              ? locationsAvailability.used - locationsAvailability.plan
              : 0,
          costPerUnit: locationsAvailability.cost_per_unit
        }
      )
      .then(
        async data => {
          const locations = data.locations;
          await accountServices.setExtraLocations(this.account.id, locations);
          this.loadAvailability();
        },
        () => {
          // Nothing to do on modal close..
        }
      );
  }

  get customerSince() {
    return (this.account && this.account.customer_since) || null;
  }

  // get lastInvoice() {
  //   return this.account.invoices[0] || null;
  // }

  get outstandingMessage() {
    return `account_management_module.${
      this.account.outstanding_amount
        ? "outstanding_message"
        : "no_outstanding_message"
    }`;
  }

  get autoBillSwitch() {
    return this.AUTO_BILL;
  }

  set autoBillSwitch(value: boolean) {
    this.loadingAutoBill = true;
    this.AUTO_BILL = value;
    accountServices
      .setAutoBill(this.account.id, value)
      .then(() => {
        this.loadAccountData();
      })
      .catch(() => (this.AUTO_BILL = this.account.auto_bill))
      .finally(() => (this.loadingAutoBill = false));
  }

  protected async loadAccountData() {
    await this.accountDataAction();
    this.AUTO_BILL = this.account && this.account.auto_bill;
  }

  protected async payInvoice(invoice: AccountManagement.BillingInvoice) {
    this.$modals
      .load<number>(PayBillModal, {
        size: "fit",
        positionY: "top"
      })
      .then(
        async cardId => {
          await accountServices.payInvoice(this.account.id, invoice.id, cardId);
          this.loadAccountData();
        },
        () => {
          // No action for modal dismissal
        }
      );
  }

  protected async mounted() {
    if (!this.loadingAvailability) {
      this.loadAvailability();
    }

    EventBus.$on("payInvoice", this.payInvoice);
    this.loadAccountData();
  }
}
